/* eslint-disable */

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

function nth(d) {
  if (d > 3 && d < 21) return 'th';
  switch (d % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}

function zeroPad(d) {
  return `0${d}`.slice(-2);
}

export default {
  parseDate(date) {
    const patternText = `^(${months.join(
      '|'
    )})\\s(\\d{1,2})(?:st|nd|rd|th)\\s(\\d{4}),\\s(\\d{1,2}):(\\d{2})$`;
    const pattern = new RegExp(patternText);

    if (!pattern.test(date)) {
      return false;
    }

    const [, monthRaw, day, year, hours, mins] = pattern.exec(date);
    const month = months.indexOf(monthRaw);

    return new Date(year, month, day, hours, mins);
  },

  formatDate(date, format) {
    if (format == 'MMMM Do YYYY') {
      return this._formatDate(date);
    }

    if (format == 'HH:mm') {
      return this._formatTime(date);
    }

    if (format == 'MMMM Do YYYY, HH:mm') {
      return `${this._formatDate(date)}, ${this._formatTime(date)}`;
    }
  },

  _formatDate(date) {
    const month = months[date.getMonth()];
    const dayOfMonth = date.getDate() + nth(date.getDate());
    return `${month} ${dayOfMonth} ${date.getFullYear()}`;
  },

  _formatTime(date) {
    return `${zeroPad(date.getHours())}:${zeroPad(date.getMinutes())}`;
  },
};
